import styled from 'styled-components';

export const FilterLabel = styled.span`
  font-size: 0.9rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primaryBlue.main};
  margin: 0;
  white-space: nowrap;
`;